<script>
    import { getCurrentDate } from './utils.js';
    let search = '';
    
    const handleSubmit = event => {
        event.preventDefault();

        const params = new URLSearchParams({
            keyword: search,
            date: getCurrentDate(),
        });

        window.location.href = `${window.location.pathname}?${params}`;
    };
</script>

<header class="w-full bg-blueish-black p-4 flex items-center justify-center relative">
    <h1 class="text-white font-bold absolute left-10">SONAR SPHERE</h1>

    <form class="w-1/3" on:submit={handleSubmit}>
        <input 
            bind:value={search}
            class="w-full px-3 py-2 rounded shadow"
            type="search" 
            placeholder="Search..." 
            name="search"
        />
        <input type="submit" style="display: none;">
    </form>
</header>